import { Trans, useLingui } from '@lingui/react/macro';

import InlineText from '@/design_system/Typography/InlineText';
import IconArchive from '@/icons/Archive.svg';
import { BaseNotification } from '@/layouts/App/Navbar/NotificationList/components/BaseNotification/BaseNotification';
import { useArticleName } from '@/models/article';
import type { TNotificationOfType } from '@/models/notification';

export const ShipmentIssueArchivedNotification = ({
  notification,
}: {
  notification: TNotificationOfType<'shipment_issue_archived'>;
}) => {
  const articleName = useArticleName({ article: notification.article });
  const { t } = useLingui();

  return (
    <BaseNotification
      icon={<IconArchive />}
      type="danger"
      notification={notification}
      notificationLabel={t({
        id: 'notification.shipment-issue-archived.label',
        message: `Item ${articleName} of request ${notification.request.reference} archived`,
      })}
      notificationHeader={(color) => (
        <Trans id="notification.shipment-issue-archived">
          The item{' '}
          <InlineText weight="medium" color={color}>
            {articleName}
          </InlineText>{' '}
          has been archived
        </Trans>
      )}
    />
  );
};
